import React from "react"

export default ({ children, isTrue = false }) =>
  isTrue ? <>{children}</> : null
